import Icon from '../components/Icon.vue'

Icon.register({"gamepad":{"width":640,"height":512,"paths":[{"d":"M480 96H160C71.6 96 0 167.6 0 256S71.6 416 160 416C204.8 416 245.2 397.6 274.2 368H365.7C394.7 397.6 435.2 416 479.9 416 568.3 416 639.9 344.4 639.9 256S568.4 96 480 96zM256 276C256 282.6 250.6 288 244 288H192V340C192 346.6 186.6 352 180 352H140C133.4 352 128 346.6 128 340V288H76C69.4 288 64 282.6 64 276V236C64 229.4 69.4 224 76 224H128V172C128 165.4 133.4 160 140 160H180C186.6 160 192 165.4 192 172V224H244C250.6 224 256 229.4 256 236V276zM440 344C413.5 344 392 322.5 392 296S413.5 248 440 248 488 269.5 488 296 466.5 344 440 344zM520 264C493.5 264 472 242.5 472 216S493.5 168 520 168 568 189.5 568 216 546.5 264 520 264z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gamepad.js
// module id = z3sX
// module chunks = 0